// Shared light/dark theme preference for the developer tools (pipeline sandbox,
// and eventually explorer / service monitor) — intentionally NOT used by the
// main dashboard. One localStorage key shared across every dev tool so the
// preference follows the developer regardless of which tool they open.

const STORAGE_KEY = 'hs.devtools.theme';
const DEFAULT_THEME = 'dark';

export function getTheme() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === 'light' || stored === 'dark' ? stored : DEFAULT_THEME;
    } catch {
        return DEFAULT_THEME;
    }
}

export function setTheme(theme) {
    const value = theme === 'light' ? 'light' : 'dark';
    try {
        localStorage.setItem(STORAGE_KEY, value);
    } catch { /* best effort */ }
    return value;
}

export function toggleTheme() {
    return setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}
